import React from 'react';
import './ModuleHeader.css';

export const ModuleHeader = ({ title, subtitle }: { title: string, subtitle: string }) => (
  <div className="module-header">
    <div className="module-header-title-wrapper">
      <div className="module-header-indicator" />
      <h2 className="module-header-title">{title}</h2>
    </div>
    <p className="module-header-subtitle">{subtitle}</p>
  </div>
);
